import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch,
} from 'antd';
import ReactQuill, { Quill } from 'react-quill';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    MinusCircleOutlined,
    PlusOutlined,
    ArrowLeftOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import TextArea from 'antd/es/input/TextArea';
import Text from 'antd/es/typography/Text';
import arrowLeft from '../../../src/img/arrow-left.png';

interface Props {
    location: any;
}

const { Title } = Typography;
const { Option } = Select;
export default function QuestionForm(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [type, setType] = useState('' as any);
    const [fetching, setFetching] = useState(true);
    const [item, setItem] = useState(null as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [uploading, setUploading] = useState(false);
    const [selectedLang, setSelectedLang] = useState('en' as any);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchQuestionByIdAdmin(RouteParams['courseId'], RouteParams['curriculumId'], RouteParams['contentId'], RouteParams['id']);
            setItem({
                ...data,
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        let localLang = localStorage.getItem("language")
        if(localLang != undefined && localLang != null && localLang != ''){
            setSelectedLang(localLang)
        }
    }, []);
    const modules = {
        toolbar: {
            container: [  
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],  
                ['bold', 'italic', 'underline'],  
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],  
                [{ 'align': [] }],  
                ['link', 'image'],  
                ['clean'],  
                [{ 'color': [] }]  
              ],  
            handlers: {
            //   image: imageHandler
            }
        }
    };
    
      const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "imageBlot" // #5 Optinal if using custom formats
      ];

    console.log(item);
    if (fetching) {
        return <Skeleton active={true}/>;
    }
    return (
        <div className={'list-page-wrapper'}>
            <div className='row'>
            <div className='col-sm-6 mb-3'>
                <div className='mr-4'>
                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                </div>
                <div><h3 className='mb-0'></h3></div>
            </div>
            </div>
            <div className="pl-sm-5 br-5 bg-white pt-3 pb-3 pr-sm-5">
                <div className="row">
                    <div className="col-md-5 mt-4">
                        <h5>Question Information</h5>
                        <p className="text-secondary">This Information will be display the identify of the administrator</p>
                    </div>
                    <div className="col-md-7 mt-4">
                        <Form
                            size="large"
                            form={form}
                            initialValues={item}
                            fields={[]}
                            onFinish={(value) => {
                                const reqObj: any = { ...value, options: value.options || [] };
                                setSaving(true);
                                if(item && item.id){
                                    API_SERVICE.updateQuestion(RouteParams['courseId'], RouteParams['curriculumId'], RouteParams['contentId'], item.id, reqObj).then((d) => {
                                        history.goBack();
                                    }).catch((e) => {
                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                        setSaving(false);
                                    });
                                }else{
                                    API_SERVICE.createQuestion(RouteParams['courseId'], RouteParams['curriculumId'], RouteParams['contentId'], reqObj).then((d) => {
                                        history.goBack();
                                    }).catch((e) => {
                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                        setSaving(false);
                                    });
                                }
                            }}
                            layout="vertical"
                            requiredMark={true}
                        >

                            <Form.Item
                                label={t('questions.label')}
                                name={['title', selectedLang]}
                                rules={[
                                    { required: true, message: t('questions.required') },
                                ]}
                            >
                                {/* <Input /> */}
                                <ReactQuill
                                    modules={modules} formats={formats} 
                                />
                            </Form.Item>
                            {/* <Form.Item
                                label={t('question.title.label')}
                                name={['title', 'en']}
                                rules={[
                                    { required: true, message: t('question.title.required') },
                                ]}>
                                <Input />
                            </Form.Item> */}
                            {/* <Form.Item
                                label={t('description.label')}
                                name={['description', selectedLang]}
                                rules={[
                                    { required: true, message: t('description.required') },
                                ]}
                            >
                                <Input />
                            </Form.Item> */}
                            {/* <Form.Item
                                label={t('question.description.label')}
                                name={['description', 'en']}
                                rules={[
                                    { required: true, message: t('question.description.required') },
                                ]}>
                                <Input />
                            </Form.Item> */}
                            <Form.Item
                                label={t('question.type.label')}
                                name={'type'}
                                rules={[
                                    { required: true, message: t('question.type.required') },
                                ]}>
                                <Select onChange={(e) => setType(e)} >
                                    <option value="radio">{t('question.singleSelect')}</option>
                                    <option value="checkbox">{t('question.multiSelect')}</option>
                                    <option value="text">{t('question.numeric')}</option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label={t('question.positiveMarks.label')}
                                name={'positve_marks'}
                                rules={[
                                    {
                                        required: true, message: t('question.positiveMarks.required'),
                                    },
                                ]}>
                                <InputNumber min={0} />
                            </Form.Item>
                            <Form.Item
                                label={t('question.negativeMarks.label')}
                                name={'negative_marks'}
                                rules={[
                                    {
                                        required: true, message: t('question.negativeMarks.required'),
                                    },
                                ]}>
                                <InputNumber min={0} />
                            </Form.Item>
                            <Form.List
                                name="options"
                                rules={[
                                    {
                                        validator: async (_, names) => {
                                            if (form.getFieldsValue()['type'] && form.getFieldsValue()['type'] !== 'text' && (!names || names.length < 2)) {
                                                return Promise.reject(new Error('At least 2 options required'));
                                            }
                                        },
                                    },
                                ]}
                            >
                                {(fields, { add, remove }, { errors }) => (
                                    <>
                                        {
                                            form.getFieldsValue()['type'] && form.getFieldsValue()['type'] !== 'text' &&
                                            <Title level={5}>{t('question.options')}</Title>
                                        }

                                        {fields.map((field, index) => (
                                            <Row gutter={20}>
                                                <Col>

                                                    <Form.Item
                                                        label={t('question.option.isCorrect.label')}
                                                        required={false}
                                                        name={[field.key, 'is_correct']}
                                                        key={field.key + 'is_correct'}
                                                        valuePropName={'checked'}
                                                        rules={[

                                                        ]}
                                                    >
                                                        <Switch />
                                                    </Form.Item>
                                                </Col>
                                                <Col flex={'auto'}>

                                                    <Form.Item
                                                        label={t('title.label')}
                                                        required={false}
                                                        name={[field.key, 'title', selectedLang]}
                                                        key={field.key + `${selectedLang === 'de' ? selectedLang.charAt(0).toUpperCase()+ selectedLang.slice(1):''}`}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: t('title.required'),
                                                            },
                                                        ]}
                                                    >
                                                        <Row gutter={20}>
                                                            <Col flex={'auto'}>
                                                                <TextArea rows={4}/>
                                                                {/* <TextArea value={item?.options ? item.options[field.key].title.en : ''} rows={4}/> */}
                                                            </Col>
                                                            <Col flex={'50px'}>
                                                                <MinusCircleOutlined
                                                                    onClick={() => remove(field.name)}
                                                                />
                                                            </Col>

                                                        </Row>
                                                    </Form.Item>
                                                    {/* <Form.Item
                                                        label={t('question.option.title.label')}
                                                        required={false}
                                                        name={[field.key, 'title', 'en']}
                                                        key={field.key + 'title'}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: t('question.option.title.required'),
                                                            },
                                                        ]}
                                                    >
                                                        <Row gutter={20}>
                                                            <Col flex={'auto'}>
                                                                <TextArea rows={4}/>
                                                            </Col>
                                                            <Col flex={'50px'}>

                                                            </Col>

                                                        </Row>
                                                    </Form.Item> */}
                                                </Col>
                                            </Row>
                                        ))}
                                        <Form.Item>
                                            {
                                                form.getFieldsValue()['type'] !== 'text' && <Button
                                                    type="dashed"
                                                    onClick={() => add()}
                                                    icon={<PlusOutlined/>}
                                                >
                                                    {t('genDict.add')}
                                                </Button>
                                            }
                                            <Form.ErrorList errors={errors}/>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                            <br/>
                            {
                                RouteParams['mode'] !== 'view' && <Form.Item>
                                    <Button
                                        htmlType="submit"
                                        loading={saving || uploading}
                                        shape="round"
                                        size={'large'}
                                        className="submit btn-blue"
                                    >
                                        {t('genDict.save')}
                                    </Button>
                                </Form.Item>
                            }
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
}
